import React, { forwardRef } from "react";
import styles from "./Input.css";

export const Group = ({ children, fieldset }) => {
  const classNames = [styles.Group, fieldset ? styles.Fieldset : null];

  return <div className={classNames.join(" ")}>{children}</div>;
};

export const Input = forwardRef(({ ...props }, ref) => {
  delete props.className;
  return <input ref={ref} className={styles.Input} {...props} />;
});

Input.Group = Group;

export default Input;
